import React from 'react';
import Header from './Header';
import LearnableHeader from './Learnable-Header';

function ComingSoon() {
	return (
		<div className='comingSoon'>
			<Header />
			<LearnableHeader />
			<h1 className='text60'>Coming soon...</h1>
		</div>
		)
}

export default ComingSoon;